import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { useAuthStore } from '@/stores/auth-store';

export const columnFilterSchema = z.object({
  id: z.string(),
  value: z.unknown(),
});

const columnFiltersSchema = z
  .union([
    z.string().transform((val) => {
      try {
        return JSON.parse(val);
      } catch {
        return [];
      }
    }),
    z.array(columnFilterSchema),
  ])
  .transform((val) => (Array.isArray(val) ? val : []));

export const searchSchema = z.object({
  columnFilters: columnFiltersSchema.optional(),
});

export const Route = createFileRoute('/')({
  component: () => <Outlet />,
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (isAuthenticated()) {
      return redirect({ to: '/attendance' });
    }
    return redirect({ to: '/login' });
  },
});
